import React, { useState } from 'react'
import { Button } from '../../lib/ui/button'
import { Toaster } from '../../lib/ui/toast'
import {
  ArrowUpTrayIcon,
  SparklesIcon,
  PlusIcon,
} from '@heroicons/react/24/outline'
import { MagicWand } from 'iconoir-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../../lib/ui/dialog'
import DropzoneCoverLetterUpload from './DropzoneCoverLetterUpload'
import { useTranslation } from '~/hooks/useTranslation'

const NewCoverLetterOptions = ({ uploadCoverLetterClick }) => {
  const { t } = useTranslation('NewCoverLetterModal')

  return (
    <div className="px-4 pb-4">
      <div className="mb-4 text-lg font-medium">
        {t('choose_your_approach')}
      </div>
      <div className="pb-4">{t('create_cover_letter_below')}</div>
      <div className="pb-4">
        <a
          href="/personal_brand/cover_letters/ai"
          className="flex h-28 w-full flex-row rounded-2.5xl bg-willow-brook text-primary"
        >
          <div className="flex items-center justify-center p-6">
            <MagicWand width="2.5rem" height="2.5rem" />
          </div>
          <div className="flex flex-col items-start justify-evenly">
            <div className="font-roboto-slab text-xl font-medium">
              {t('ayla_cover_letter')}
            </div>
            <div>{t('custom_ai_cover_letter')}</div>
          </div>
        </a>
      </div>
      <div className="pb-4">
        <a
          href="/personal_brand/cover_letter_builder/new"
          className="flex h-28 w-full flex-row rounded-2.5xl bg-lily-blue text-primary"
        >
          <div className="flex items-center justify-center p-6">
            <PlusIcon className="w-10" />
          </div>
          <div className="flex flex-col items-start justify-evenly">
            <div className="font-roboto-slab text-xl font-medium">
              {t('general_cover_letter')}
            </div>
            <div>{t('fill_the_fields')}</div>
          </div>
        </a>
      </div>
      <div className="pb-4">
        <button
          onClick={uploadCoverLetterClick}
          className="flex h-28 w-full flex-row rounded-2.5xl bg-lily-blue text-primary"
        >
          <div className="flex items-center justify-center p-6">
            <ArrowUpTrayIcon className="w-10" />
          </div>
          <div className="flex flex-col items-start justify-evenly">
            <div className="font-roboto-slab text-xl font-medium">
              {t('upload_your_cover_letter')}
            </div>
            <div>{t('existing_formats')}</div>
          </div>
        </button>
      </div>
    </div>
  )
}

const NewCoverLetterModal = ({
  buttonVariant,
  buttonText,
  buttonIcon,
  buttonClass,
}) => {
  const [open, setOpen] = useState(false)
  const [uploadCoverLetterMode, setUploadCoverLetterMode] = useState(false)

  const uploadCoverLetterClick = () => {
    setUploadCoverLetterMode(true)
  }

  const toggleOpen = () => {
    setOpen(!open)
    setUploadCoverLetterMode(false)
  }

  const { t } = useTranslation('NewCoverLetterModal')

  return (
    <Dialog
      open={open}
      onOpenChange={toggleOpen}
      className="rounded-2xl lg:max-w-[37rem] xl:max-w-[37rem]"
    >
      <DialogTrigger asChild className="cursor-pointer">
        <Button variant={buttonVariant} className={buttonClass}>
          {buttonText || t('create_a_new_cover_letter')}{' '}
          {buttonIcon &&
            React.cloneElement(buttonIcon, {
              className: 'size-5 w-6 inline pl-1',
            })}
        </Button>
      </DialogTrigger>
      <DialogContent
        className="fix-legacy-hack font-roboto lg:max-w-3xl xl:max-w-5xl"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle className="text-left" asChild>
            <h2 className="text-2xl">
              {t('create_your_cover_letter')}
              <SparklesIcon className="ml-2 inline w-6" />
            </h2>
          </DialogTitle>
        </DialogHeader>
        {!uploadCoverLetterMode && (
          <NewCoverLetterOptions
            uploadCoverLetterClick={uploadCoverLetterClick}
          />
        )}
        {uploadCoverLetterMode && <DropzoneCoverLetterUpload />}
      </DialogContent>
      <Toaster />
    </Dialog>
  )
}
export default NewCoverLetterModal
